module.exports = __webpack_public_path__ + "img/pay_02.972e5fa8.png";